export default __webpack_public_path__ + "static/media/icon_survey_very_satisfied.f032ef35.svg";